import "./Checkout.css";
import FrameRight from "./FrameRight";
import FrameLeft from "./boxleft/Frameleft";
import { useEffect, useState } from "react";
import { getProductsOfCart } from "../../network/api/product.js";
import { get_cart } from "../../network/api/cart.js";
import { getFees, getShippingExpenses } from "../../network/api/ShippingFees.js";
import Frame425 from "./boxleft/Frame425.js";

function Checkout() {
  const [cartItems, setCartItems] = useState([]);
  const [ProductItems, setProductItems] = useState([]);
  const [GetTotalQuantity, setGetTotalQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [fees, setFees] = useState(0);
  const [shippingExpenses, setShippingExpenses] = useState(0);
  const [checkoutPayment, setCheckoutPayment] = useState(false);

  const couponCode = localStorage.getItem('couponCode') || '';
  const discountPercentage = parseFloat(localStorage.getItem('discountPercentage')) || 0;

  const load = async () => {
    const productArr = [];
    const cartArr = await get_cart();

    
    cartArr?.forEach((element) => {
      productArr.push(element.product_id);
    });
    const products = await getProductsOfCart(productArr);
    setCartItems(cartArr);
    setProductItems(products);
    var total = 0;
    products?.forEach((element, index) => {
      total += element.price_after * cartArr[index].quantity;
    });
    setTotalPrice(total);

  };

 
  

  useEffect(() => {
    const fetchShippingExpenses = async () => {
      const response = await getShippingExpenses();
      setShippingExpenses(response.data.amount); // Set shipping expenses from backend
    };
    fetchShippingExpenses()
    load();
  }, []);

  useEffect(() => {
    getFees().then((response) => {
      setFees(response?.data?.shipping_fees);
    });
  },[]);

  useEffect(() => {
    let total = 0;
    cartItems.forEach((element) => {
      total += element.quantity;
    });
    setGetTotalQuantity(total);
  }, [cartItems]);
  return (
    <div className="checkout bg-white pt-4">
      <div className="container-lg">
        <Frame425
          checkoutPayment={checkoutPayment}
          setCheckoutPayment={setCheckoutPayment}
        />
        <div className="d-flex justify-content-center">
          <FrameLeft
          couponCode={couponCode}
            totalPrice={totalPrice}
            cartItems={cartItems}
            fees={fees}
            checkoutPayment={checkoutPayment}
            setCheckoutPayment={setCheckoutPayment}
            ProductItems={ProductItems}
          />
          <FrameRight
          shippingExpenses={shippingExpenses}
            fees={fees}
            ProductItems={ProductItems}
            GetTotalQuantity={GetTotalQuantity}
            totalPrice={totalPrice}
            discountPercentage={discountPercentage}
            cartItems={cartItems}
          />
        </div>
      </div>
    </div>
  );
}
export default Checkout;
